import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { RouterModule, Routes } from "@angular/router";
import { OptionsHttp } from "providers/http/OptionsHttp";
import { LoginHttp } from "providers/http/LoginHttp";
import { MainHttp } from "providers/http/MainHttp";
import { Lobby } from "./Lobby";
import { CommonModule } from "@angular/common";
import { App } from "components/app/App";
import { ProfileLobbyModule } from "./profileLobby/ProfileLobbyModule";
import { ImageErrorModule } from "directives/ImageError";


@NgModule({
    declarations: [
        Lobby
    ],
    imports: [
        FormsModule,
        CommonModule,
        ImageErrorModule,
        ProfileLobbyModule,
        RouterModule
    ],
    providers: [
        OptionsHttp,
        LoginHttp,
        MainHttp,
        App
    ],
    entryComponents: [],
    exports: []
})
export class LobbyModule {
}